import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const normalizePlan = (plan) => {
  if (!plan) return null;
  const p = plan.toLowerCase();
  if (p.includes('basic') || p.includes('explor')) return 'basic';
  if (p.includes('premium') || p.includes('navigat')) return 'premium';
  if (p.includes('enterprise') || p.includes('pathfinder') || p.includes('pionnier')) return 'enterprise';
  return p;
};

const ProtectedRoute = ({ children, requiredPlan }) => {
  const { isAuthenticated, user, loading } = useAuth();
  if (loading) return <div style={{ textAlign: 'center', marginTop: '50px' }}>Loading...</div>;
  if (!isAuthenticated || !user) return <Navigate to="/signin" replace />;
  const userPlan = normalizePlan(user.plan);
  const required = normalizePlan(requiredPlan);
  if (required && userPlan !== required) return <Navigate to="/dashboard" replace />;
  return children;
};

export default ProtectedRoute;
